import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { GridLayoutList } from '@gem/call/CallView/Shared/GridLayout/components/GridLayoutList/GridLayoutList';
import { useOpponentsVideo } from '@gem/call/CallView/hooks/useOpponentsVideo/useOpponentsVideo';
import { AvatarTypes } from '@gem/call/Removable/components/Avatar/Avatar';

interface IGridLayoutProps {
  avatarLargeType: AvatarTypes;
  avatarMediumType: AvatarTypes;
  getClassName(length: number): string;
}

export const GridLayout: FC<IGridLayoutProps> = observer(
  ({ avatarLargeType, avatarMediumType, getClassName }) => {
    const { opponentsKeys } = useOpponentsVideo(true);

    return (
      <div className={getClassName(opponentsKeys.length)}>
        <GridLayoutList
          opponentsKeys={opponentsKeys}
          avatarType={opponentsKeys.length > 2 ? avatarMediumType : avatarLargeType}
        />
      </div>
    );
  }
);
